// Add your custom JS here.

// Adjust mobile viewports to allow menu parent items to open up
jQuery(function ($) {
    function applyMobileToggle() {
        if (window.matchMedia('(max-width: 1199px)').matches) {
            $("#main-menu .dropdown-toggle").attr('data-toggle', 'dropdown');
            $("#main-menu .dropdown-toggle").attr('data-bs-toggle', 'dropdown');
        } else {
            $("#main-menu .dropdown-toggle").removeAttr('data-toggle dropdown');
            $("#main-menu .dropdown-toggle").removeAttr('data-bs-toggle dropdown');
        }

    }

    // Run on page load
    applyMobileToggle();

    // Run on window resize
    $(window).resize(function () {
        applyMobileToggle();
    });
});

// Set all testimonial carousel items to the same height
function carouselNormalization() {

    window.heights = [], //create empty array to store height values
        window.tallest; //create variable to make note of the tallest slide

    function normalizeHeights() {
        jQuery('.carousel .carousel-inner .carousel-item.testimonial').each(function () { //add heights to array
            window.heights.push(jQuery(this).outerHeight());
        });
        window.tallest = Math.max.apply(null, window.heights); //cache largest value
        jQuery('.carousel .carousel-inner .carousel-item.testimonial').each(function () {
            jQuery(this).css('min-height', tallest + 'px');
        });
    }
    normalizeHeights();

    jQuery(window).on('resize orientationchange', function () {
        window.tallest = 0, window.heights.length = 0; //reset vars
        jQuery('.carousel .carousel-inner .carousel-item.testimonial').each(function () {
            jQuery(this).css('min-height', '0'); //reset min-height
        });

        normalizeHeights(); //run it again 

    });

    if (jQuery(this).css("display") == 'block') {
        was_show = 1;
    } else {
        jQuery(this).addClass("active");
        var was_show = 0;
    }

    window.heights.push(jQuery(this).outerHeight());

    if (was_show == 0) {
        jQuery(this).removeClass("active");
    }

}

jQuery(document).ready(function () {
    carouselNormalization();
});
